// App.jsx
import React, { useState, useEffect } from 'react';
import './styles.css'; 

// 🔥 COMPONENT IMPORTS
import Header from './components/Header.jsx';
import Hero from './components/Hero.jsx';
import About from './components/About.jsx';
import Services from './components/Services.jsx';
import Projects from './components/Projects.jsx';
import Achievements from './components/Achievements.jsx'; 
import Testimonials from './components/Testimonials.jsx'; // 🔥 NEW IMPORT
import Contact from './components/Contact.jsx';
import Footer from './components/Footer.jsx';

function App() {
  const [theme, setTheme] = useState('dark');

  const toggleTheme = () => {
    setTheme(currentTheme => (currentTheme === 'light' ? 'dark' : 'light'));
  };

  useEffect(() => {
    document.body.className = theme;
  }, [theme]);

  // --- Updated Company Data for Devulex ---
  const companyData = {
    owner: "ARULSELVAN KARTHIKEYAN, the owner of DEVULEX, holds a B.E. degree from the prestigious RMK College of Engineering and Technology, Chennai. He leverages his comprehensive engineering foundation to excel in both freelance projects and professional software development jobs.",
    company: "DEVULEX",
    email:"devulexcompany@gmail.com",
    phone: "+91 76048 94997",
    location: "1052,sengundhar street,vilandai-Andimadam,Ariyalur District,621801,TamilNadu,India",
    social: {
      linkedin: "https://linkedin.com/in/arulselvan_karthikeyan",
      github: "https://github.com/devulex",
      instagram: "https://instagram.com/devulex"
    },
    skills: {
      frontend: ['HTML5', 'CSS3', 'JavaScript (ES6+)', 'React', 'Vue.js', 'Responsive Design'],
      backend: ['Node.js', 'Python (Django/Flask)', 'Express.js', 'REST APIs', 'Authentication (JWT)'],
      database: ['PostgreSQL', 'MongoDB', 'MySQL', 'Database Optimization'],
      tools: ['Git/GitHub', 'Docker', 'AWS/Vercel Deployment', 'VS Code'],
UIUX: [
  'Figma',
  'Adobe XD',
  'Wireframing',
  'Prototyping',
  'User Experience (UX)',
  'User Interface (UI)',
  'Design Systems'
]

    },
    // 🔥 PROJECTS   DATA
    projects: [
      {
        id: 1,
        name: "Tamil Manamalai Trust Website",
        description: "A comprehensive informational and functional website for the Tamil Manamalai Trust, featuring donation/trust-related pages and secure payment integration.",
        tech: ["React", "Spring Boot", "PostgreSQL", "Payment Gateway"],
        demo: "https://tamilmanamalaitrust.com/",
        github: "#", 
        imageUrl: "/images/tamilmanamalai.jpg", 
      },
      {
        id: 2,
        name: "E-Commerce Platform",
        description: "A full-featured e-commerce website complete with product listings, a shopping cart, a secure payment gateway, and a dedicated administrator control panel.",
        tech: ["React", "Spring Boot", "MySQL", "Payment Gateway", "Admin Panel"],
        demo: "#", 
        github: "#", 
        imageUrl: "/images/ecommerce_platform.jpg",
      },
      {
        id: 3,
        name: "Student Database & Grading System",
        description: "A centralized system for managing student records, viewing marks, calculating grades, and providing reporting access for parents/guardians.",
        tech: ["PHP", "MySQL", "Excel Integration"],
        demo: "#", 
        github: "#", 
        imageUrl: "/images/student_database.jpg",
      },
    ],
    // 🔥 ACHIEVEMENTS DATA
    achievements: [
      {
        id: 1,
        title: "AWS Certified Developer – Associate",
        issuer: "Amazon Web Services (AWS)",
        date: "2024-05",
        description: "Validated technical proficiency in developing and maintaining applications on the AWS platform.",
        certificateUrl: "/certificates/aws_dev_cert.pdf",
        imageUrl: "/badges/aws_badge.png",
      },
      {
        id: 2,
        title: "Full Stack Development Bootcamp Completion",
        issuer: "Tech Academy",
        date: "2023-12",
        description: "Completed 600+ hours of hands-on training covering MERN stack, database design, and deployment pipelines.",
        certificateUrl: "/certificates/fsd_bootcamp.pdf",
        imageUrl: "/badges/bootcamp_logo.png",
      },
    ],
    // 🔥 NEW TESTIMONIALS DATA STRUCTURE
    testimonials: [
        {
            id: 1,
            quote: "Devulex transformed our outdated platform into a high-performance, modern application. The attention to detail and communication was outstanding!",
            name: "Alex P.",
            title: "CEO, Tech Innovators"
        },
        {
            id: 2,
            quote: "Scalable, robust, and delivered ahead of schedule. Their full-stack expertise is the reason our launch was a massive success.",
            name: "Maria K.",
            title: "Project Manager, Global Solutions"
        },
        {
            id: 3,
            quote: "The team provided insightful solutions to complex scaling issues. Truly professional and highly skilled in modern web technologies.",
            name: "Jordan S.",
            title: "CTO, Digital Agency"
        },
    ],
  };
  // -----------------------------------

  return (
    <div id="portfolio-app" className={theme}>
      <Header 
        companyName={companyData.company} 
        theme={theme} 
        toggleTheme={toggleTheme} 
      />

      <main>
        <section id="home"><Hero companyData={companyData} /></section>
        <section id="about"><About companyData={companyData} /></section>
        <section id="services"><Services skills={companyData.skills} /></section>
        
        {/* Project Section */}
        <section id="projects"><Projects projects={companyData.projects} /></section>
        
        {/* Achievements Section */}
        <section id="achievements">
            <Achievements achievements={companyData.achievements} />
        </section>
        
        {/* 🔥 TESTIMONIALS SECTION PLACEMENT */}
        <section id="testimonials">
            <Testimonials testimonials={companyData.testimonials} />
        </section>
        
        <section id="contact"><Contact companyData={companyData} /></section>
      </main>

      <Footer companyName={companyData.company} social={companyData.social} />
    </div>
  );
}

export default App;